import { stickersOnboardingActionTypes } from './constants';

interface StickersOnboardingState {
	loading: boolean;
}

const initialState: StickersOnboardingState = {
	loading: false,
};

export default function stickersOnboardingReducer(
	state = initialState,
	action: { type: string },
): StickersOnboardingState {
	switch (action.type) {
		case stickersOnboardingActionTypes.SEND_STICKERS_ONBOARDED_REQUEST:
			return { ...state, loading: true };
		default:
			return state;
	}
}
